/**
 * Converts a pixel value to a rem string (based on a 16px root font size).
 * @param {number} [size] - The pixel value to convert. Defaults to 0 when nullish.
 * @returns {string} The value expressed in rem, e.g. `1rem`.
 */
const toRem = size => `${(size ?? 0) / 16}rem`;

export default toRem;
